import { useEffect, useRef, useContext } from 'react';
import { RideEventsContext } from '../context/RideEventsContext';

export function useRideEvents(onRefresh) {
  const ctx = useContext(RideEventsContext);
  const onRefreshRef = useRef(onRefresh);
  useEffect(() => { onRefreshRef.current = onRefresh; });

  useEffect(() => {
    if (!ctx) return undefined;
    return ctx.subscribe(() => onRefreshRef.current());
  }, [ctx]);
}
